import { createContext, useContext } from "react";
import type { AutopilotView } from "@auto-pools/core";
import type { Resource } from "../api/useResource";

export interface AutopilotValue extends Resource<AutopilotView> {
  blocksManualOpening: boolean;
  /** Applies a command's returned view directly (D2): see `useAutopilotResume`. */
  updateData: (updater: (data: AutopilotView | null) => AutopilotView | null) => void;
}

// Exported so tests can inject a value directly (mirrors RuntimeStatusContext) without a real fetch.
export const AutopilotContext = createContext<AutopilotValue | null>(null);

export function useAutopilot() {
  const value = useContext(AutopilotContext);
  if (!value) throw new Error("useAutopilot must be used inside AutopilotProvider");
  return value;
}
